<template>
    <survey :survey="survey" :isExpanded="true"/>
</template>
<script>
import Vue from "vue";
import { Model } from "survey-vue";
import "./defaultV2.min.css";
//import "survey-vue/default.min.css";
import "./index.css";
import { json } from "./json";
import { setSubmitSurvey }  from '@/api/view/hip/common/common.js'

var storageName = "SurveyJS_LoadState";
var timerId = 0;
const SURVEY_ID = "001" ;
var resultList = [] ;

const customCss = {
    "question": {
        "content": "question-content",
        "answered": "question-answered",
        "titleRequired": "question-title-required"
    }
};

function saveState(survey, user) {
    var res = { currentPageNo: survey.currentPageNo, data: survey.data};
    //Here should be the code to save the data into your database
    window.localStorage.setItem(storageName, JSON.stringify(res));

    //console.log(survey.data)

    Object.keys(survey.data).forEach(function(key) {
        var promote1 = ' ', promote2 = ' ', promote3 = ' ', answCode = ' ', answDesc = ' '
        if(key == "promoteFeatures") {
            promote1 = survey.data.promoteFeatures[0]
            promote2 = survey.data.promoteFeatures[1]
            promote3 = survey.data.promoteFeatures[2]
            answCode = key
            //answDesc = survey.data[key]
        } 
        else if(key == "promoteFeatures-Comment"){
            answCode = key
            answDesc = survey.data[key]
        }else{
            answCode = key
            answDesc = survey.data[key]
        }

        var dataObj = {
          sysNo: "HIP" , surveyId: SURVEY_ID, makerCd: user.makerCd, quesCd: key, 
          answCd: answCode, answDesc: answDesc , 
          promote01: promote1, promote02: promote2, promote03: promote3, promote04: ' ', promote05 :' ', rmk : ' ' , 
          rgstEmp: user.userId, rgstIp : user.userIp
        }
        resultList.push(dataObj) 

    }) ;

    //console.log(resultList) ;

    setSubmitSurvey(resultList).then(res => {
        const msg = res.body ;
        if(msg == 'Y') {
            console.log(msg)
        } else {
            console.log(msg)
        }
    });
}

export default {
  name: 'surveyComponent',
  data() {
    const survey = new Model(json);
    survey.onCurrentPageChanged.add((survey, options) => {
        saveState(survey);
    });
  
    survey.onComplete.add((sender, options) => {
        saveState(sender, this.user);
    });

    survey.css = customCss;
    
    survey.onUpdateQuestionCssClasses.add(function(_, options) {
        const classes = options.cssClasses;
        classes.root = "question-root";
        if (options.question.getType() === "checkbox") {
            classes.root += " question-root-checkboxes";
        }
    });
    
    return {
      resultList: [],
      user: {
        makerCd: this.$store.state.user.makerCd,
        userId:  this.$store.state.user.userId,
        userIp: this.$store.state.user.userIp
      }, 
      survey: survey

    };  
  },

} ;
</script>